import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { FormattedMessage } from 'react-intl';

import type { MissingCargoData } from '#domain/loadMetrics.ts';

const missingDataMessageIds: Record<MissingCargoData, string> = {
    weight: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.load-metrics.missing-weight.tooltip',
    loadingMeter: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.load-metrics.missing-loading-meter.tooltip',
    quantity: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.load-metrics.missing-quantity.tooltip',
    weightAndLoadingMeter:
        'intl-msg:ordercom-cloud-frontend.tours.create-dialog.load-metrics.missing-weight-and-loading-meter.tooltip',
};

export const LoadMetricsWarningIcon = ({ missingData }: { missingData: MissingCargoData }) => {
    return (
        <FormattedMessage id={missingDataMessageIds[missingData]}>
            {message => (
                <SimpleTooltip content={message.toString()}>
                    <span
                        aria-label={message.toString()}
                        className='display-flex align-items-center justify-content-center flex-0'
                        data-testid='load-metrics-value-state-icon-target'
                        role='img'
                    >
                        <span
                            aria-hidden='true'
                            className='uikit-icon icon-warning-sign text-color-warning text-size-18'
                            data-testid='load-metrics-value-state-icon'
                        />
                    </span>
                </SimpleTooltip>
            )}
        </FormattedMessage>
    );
};
